import { useQuery } from '@tanstack/react-query';
import { fetchSyncLogs, type SyncLogsParams } from '@/lib/api';

export function useSyncLogs(params: SyncLogsParams = {}) {
  return useQuery({
    queryKey: ['sync-logs', params],
    queryFn: () => fetchSyncLogs(params),
    placeholderData: (prev) => prev,
    staleTime: 10_000,
  });
}
